module.exports = require('./helpers/bundle-url').getBundleURL('byUka') + "inclusivity.1803cd50.jpeg" + "?" + Date.now();